import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'warranty': null,
  'loading': false,
};

export const updateWarranty = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.UPDATING_TWC_WARRANTIES]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.UPDATED_TWC_WARRANTIES]: (state, action) => {
      return ({
        ...state,
        'loading': false,
        'warranty': action.response.data,
      });
    },
    [ActionTypes.UPDATED_TWC_WARRANTIES_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'warranty': null,
    }),
    [ActionTypes.CLEAR_UPDATE_WARRANTY]: (state, action) => ({
      ...state,
      'loading': false,
      'warranty': null,
    }),
  })(state, action);
};
